// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3q97M","label":"Radio_label__1oAQy","checkMark":"Radio_checkMark__2RW3n","disabled":"Radio_disabled__3AqFg"};